import AbstractCommand from "../../../core/application/AbstractCommand";
import SaveGameService from "./SaveGameService";
import SaveGameModel from "../model/SaveGameModel";
import FileModel from "../../../ngt/files/model/FileModel";
import ChatModel from "../../../ngt/chat/model/ChatModel";
import EmailModel from "../../../ngt/email/model/EmailModel";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import NGTVariableManager from "../../../ngt/base/NGTVariableManager";
import StoryFrameworkPlayerMemento from "../../../../../lib/html5-software-library/src/ranj/eng/story/framework/player/StoryFrameworkPlayerMemento";
import { getURLParameter } from "../../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import NPCModel from "../../../ngt/scenario/NPCModel";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import SaveGameEvent from "../events/SaveGameEvent";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTDialogFactory from "../../../ngt/dialog/NGTDialogFactory";
import ContextEvent from '../../../core/application/ContextEvent';
import ProgressGameModel from "../model/ProgressGameModel";

export default class LoadGameCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveGameService} saveGameService 
     * @param {SaveGameModel} saveGameModel 
     * @param {FileModel} fileModel 
     * @param {ChatModel} chatModel 
     * @param {EmailModel} emailModel 
     * @param {NPCModel} npcModel 
     * @param {NGTScenarioPlayer} scenarioPlayer 
     * @param {NGTVariableManager} variableManager 
     * @param {RevisableLanguagePack} languagePack 
     * @param {NGTDialogFactory} dialogFactory
     * @param {ProgressGameModel} progressGameModel
     */
    constructor(dispatcher, saveGameService, saveGameModel, fileModel, chatModel, emailModel, npcModel, scenarioPlayer, variableManager, languagePack, dialogFactory, progressGameModel) {
        super(dispatcher);

        this._saveGameService = saveGameService;
        this._saveGameModel = saveGameModel;

        this._fileModel = fileModel;
        this._chatModel = chatModel;
        this._emailModel = emailModel;
        this._npcModel = npcModel;
        this._scenarioPlayer = scenarioPlayer;
        this._variableManager = variableManager;
        this._languagePack = languagePack;
        this._dialogFactory = dialogFactory;
        this._progressGameModel = progressGameModel;
    }

    execute(evt) {
        if (!this._saveGameService.saveGameExists()) {
            return;
        }

        this._saveGameService.load()
            .then(() => {
                try {
                    if (this._saveGameModel.gameFinished) {
                        //TODO: show result screen when it has been added to the project:
                        var contextEvent = new ContextEvent(ContextEvent.START_GAME);
                        this._dispatcher.dispatch(contextEvent.type, { data: contextEvent });
                        // this.gotoScreen(SkinKeyRegistry.FEEDBACK_SCREEN_SKIN);
                        // this._dispatcher.dispatch(SaveGameEvent.GAME_LOADED);
                        return;
                    }

//TODO: add TeaCornerModel, KeyDecisionsModel
                    this._progressGameModel.fromObject(this._saveGameModel.progress);
                    this._chatModel.fromObject(this._saveGameModel.chats, this._languagePack);
                    this._emailModel.fromObject(this._saveGameModel.emails, this._languagePack);
                    this._npcModel.fromObject(this._saveGameModel.npcs, this._languagePack);
                    this._variableManager.setState(this._saveGameModel.variables);
                    // TEMP: Load files in play scenario command as we need the story LP to be initialized

                    // Get all dialogs from the chats to populate their LP entries
                    for (let i = 0; i < this._chatModel.conversations.length; i++) {
                        const chatConversation = this._chatModel.conversations[i];
                        for (let j = 0; j < chatConversation.dialogIdHistory.length; j++) {
                            const dialogId = chatConversation.dialogIdHistory[j];
                            this._dialogFactory.getDialog(dialogId);
                        }
                    }                    

                    console.log(`[LoadGameCommand] Successfully loaded save game`);

                    this._dispatcher.dispatch(SaveGameEvent.GAME_LOADED);
                } catch (ex) {
                    console.warn(`[LoadGameCommand] Unable to load save game`, ex);
//TODO: uncomment the clear
                    //this._saveGameService.clear();
                    this._dispatcher.dispatch(SaveGameEvent.GAME_LOADED);
                }
            });
    }
}